import { render } from "./SiteUser.vue?vue&type=template&id=d8beb086&scoped=true&ts=true"
import script from "./SiteUser.vue?vue&type=script&lang=ts"
export * from "./SiteUser.vue?vue&type=script&lang=ts"

import "./SiteUser.vue?vue&type=style&index=0&id=d8beb086&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8beb086"]])

export default __exports__